module.exports = __webpack_public_path__ + "img/6.3ee11de5.webp";